<template>
  <button
    :class="[
      'crispy-button',
      `crispy-button--${variant}`
    ]"
  >
    <slot />
  </button>
</template>

<script>
export default {
  name: 'CrispyButton',
  props: {
    variant: {
      type: String,
      default() {
        return 'primary';
      },
      validator(value) {
        return ['primary', 'ghost'].includes(value)
      }
    }
  }
}
</script>

<style scoped lang="scss">

.crispy-button {
  border: none;
  cursor: pointer;
  transition: all $motion-duration-standard $motion-timing-standard;

  &--primary {
    background-color: $color-surface-primary;
    color: $color-text-primary;

    &:hover {
      background-color: $color-surface-primary-hover;
    }

    &:active {
      background-color: $color-surface-primary-active;
    }
  }

  &--ghost {
    background-color: $color-surface-ghost;
    color: $color-text-secondary;

    &:hover {
      background-color: $color-surface-ghost-hover;
      color: $color-text-primary;
    }

    &:active {
      background-color: $color-surface-ghost-active;
    }
  }

  @media (max-width: $breakpoint-tablet) {
    // color: $color-ming;
  }
  
  @media (max-width: $breakpoint-mobile) {
    // color: $color-white;
  }
}


</style>
